import useTeamGoals from './useTeamGoals';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';
import { WhiteSection } from 'components/base/layout-components';
import { CenterLoader } from '@linearb/linui-common';
import styled from 'styled-components';

const WhiteSectionWrapper = styled(WhiteSection)`
  display: flex;
  align-items: center;

  > div {
    width: 100%;
  }
`;

const TeamGoals = ({ history, match, gitScopeToggle }) => {
  const { customDashboardsFiltered, loaded } = useTeamGoals(gitScopeToggle);

  if (
    !loaded ||
    !customDashboardsFiltered ||
    !customDashboardsFiltered?.component
  ) {
    return (
      <WhiteSectionWrapper t='1rem' b='1rem' height='100%'>
        <CenterLoader />
      </WhiteSectionWrapper>
    );
  }

  return customDashboardsFiltered.component();
};

export default withErrorBoundary(TeamGoals, 'Metrics');
